<template>
  <b-form-group
    label="Telefon 2"
    label-for="phone2"
  >
    <b-form-input
      id="phone2"
      v-model="dataItem.phone2"
      placeholder="Telefon 2"
    />
  </b-form-group>
</template>

<script>
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'PhoneNumber2',
  components: {
    BFormGroup,
    BFormInput,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['tenants/dataItem']
    },
  },
}
</script>
